import { View } from "extensions/marionette";

import { TabBodyView } from "./tabBody";
import { pieWidgetMixin } from "../pie/pieWidgetView";
import pieWidgetBodyTemplate from "./pieChartBody.jst";

const PieWidgetBody = View.extend({
    ...pieWidgetMixin,
    template: pieWidgetBodyTemplate,
    regions: {
        legend: ".card-list",
        chart: ".card-chart"
    },
    
    childViewEvents: {
        drilldown(child, actor, event) {
            this.getOption("widget").drilldownToSecondPivot(event, actor);
        }
    },
    
    getChartHeight() {
        return this.getOption("parent").getChartHeight();
    },
    
    drillDownFromPie({ event, actor, widget }) {
        return widget.drilldownToSecondPivot(event, actor);
    },
    
    getEntriesLimit() {
        const $el = this.getOption("widget").$el;
        const isSideBySide = this.model.get("w") >= 6;
        const ENTREE_HEIGHT = isSideBySide ? 48 : 36;
        const tabsHeight = 41;
        const summaryBarHeight = this.model.isSummaryEnabled() ? 65 : 0;
        const spaceAboveLegend = isSideBySide ? 20 : this.getChartHeight(); // 20 is top padding
        const widgetHeight = $el.outerHeight(true) - $el.find(".header").outerHeight(true) - tabsHeight - summaryBarHeight;
        
        return Math.max(0, Math.floor((widgetHeight - spaceAboveLegend) / ENTREE_HEIGHT) - 1); // 1 is left for "Others"
    },
    
    onRender() {
        this.setGroupedCollection();
        this.addChart({
            widget: this.getOption("widget")
        });
        this.addLegend();
    },
    
    onDestroy() {
        this.unsetGroupedCollection();
    }
});

export const PieChartBody = TabBodyView.extend({
    className: "pie-body",
    
    getChartHeight() {
        return this.getOption("widget").getAvailableHeight(20);
    },
    
    makeContentBody() {
        return new PieWidgetBody({
            collection: this.collection,
            model: this.getOption("widget").model,
            widget: this.getOption("widget"),
            parent: this
        });
    }
});
